module.exports = __webpack_public_path__ + "static/media/gray_animal_mammals.10af6289.webp";